<template>
  <div class="Exam-Wait-Outer">
  <div class="Exam-Wait-Inner">
  <div class="Wait-Header-Main">
  <span>{{shortdescr}}</span>
  </div>
  <div class="Wait-Padding">
  </div>
  <div class="Wait-Padding">
  </div>
  <div class="Wait-Padding">
  </div>
  <div class="Wait-Header">
  <span>{{waitMessage}}</span>
  </div>
  <div class="Wait-Padding">
  </div>
  <div class="Wait-Padding">
  </div>
  <div class="Wait-Padding">
  </div>
  </div>
  </div>
</template>
<script>

export default {
  name: 'WaitResult',
  props: ['shortdescr', 'waitMessage'],
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.Exam-Wait-Outer {
  width: 700px;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  align-content: center;
}
.Exam-Wait-Inner {
  width: 700px;
  height: 200px;
  border-style: solid;
  border-width: 5px;
  border-color: lightgrey;
}
.Wait-Header-Main {
  background-color: #317082;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: white;
}
.Wait-Header-Main span {
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 0;
}
.Wait-Header {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.Wait-Header span {
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 0;
}
.Result-message {
  padding-left: 10px;
}
.Result-message p{
  font-size: 15px;
  margin-bottom: 0;
}
.Wait-Padding {
  height: 20px;
}
@media screen and (max-width:720px) {
  .Exam-Wait-Inner {
    width: 100%;
  }
  .Exam-Wait-Outer {
    width: 100%;
  }
  .Wait-Padding {
    height: 10px;
  }
  .Wait-Header-Main {
    height: 20px;
    line-height: 20px;
  }
  .Wait-Header-Main span {
    font-size: 15px;
  }
  .Wait-Header {
    height: 30px;
    line-height: 30px;
  }
  .Wait-Header span {
    font-size: 15px;
  }
  .Result-message {
    padding-left: 5px;
  }
  .Result-message p{
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WaitResult.vue